<template>
  <div>
    <a-form style="max-width: 500px; margin: 40px auto 0;">
      <a-form-item label="账户当前余额" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <span style="color:green">{{surplusmoney}} 元</span>
      </a-form-item>
      <a-form-item label="充值金额" :labelCol="labelCol" :wrapperCol="wrapperCol" :extra="tips">
        <a-input-number
          type="number"
          v-model="inputMoney"
          :defaultValue="$parent.$parent.money"
          :min="0"
          :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
        />
      </a-form-item>
      <a-form-item :wrapperCol="{span: 19, offset: 5}">
        <a-button type="primary" @click="nextStep">提交</a-button>
        <a-button style="margin-left: 8px" @click="goBackList">返回列表</a-button>
      </a-form-item>
    </a-form>
    <a-divider/>
    <div class="step-form-style-desc">
      <h3>说明</h3>
      <h4>填写金额提交后将生成二维码，请使用微信小程序扫码充值二维码。</h4>
    </div>
  </div>
</template>

<script>
import { sellerRecharge } from '@/api/SellerCoupons'
import { getSellersCoupons } from '@/api/Main'
export default {
  name: 'Step1',
  data() {
    return {
      surplusmoney: '',
      inputMoney: 0,
      sellerDispercent: 1, //充值折扣
      labelCol: { lg: { span: 5 }, sm: { span: 5 } },
      wrapperCol: { lg: { span: 19 }, sm: { span: 19 } },
      tips: ''
    }
  },
  created() {
    this.inputMoney = this.$parent.$parent.money
    this.GetSellersCouponsData()
  },
  methods: {
    GetSellersCouponsData: function() {
      var VM = this
      getSellersCoupons('').then(res => {
        VM.surplusmoney = res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
        if (res.result.sellerDispercent != null) {
          VM.sellerDispercent = res.result.sellerDispercent.dvalue
          if (VM.sellerDispercent < 1) {
            VM.tips = '当前充值享受' + VM.sellerDispercent * 10 + '折优惠'
          }
        }
      })
    },
    nextStep() {
      if (this.inputMoney > 0) {
        sellerRecharge({ payment: this.inputMoney }).then(res => {
          if (res.status === 0) {
            this.$emit('nextStep', this.inputMoney, this.sellerDispercent, res.result.qrId)
          }
        })
      } else {
        this.$message.error('充值金额需大于0')
      }
    },
    goBackList() {
      this.$emit('goBackList')
    }
  }
}
</script>

<style lang="less" scoped>
.step-form-style-desc {
  padding: 0 56px;
  color: rgba(0, 0, 0, 0.45);

  h3 {
    margin: 0 0 12px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 16px;
    line-height: 32px;
  }

  h4 {
    margin: 0 0 4px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
  }

  p {
    margin-top: 0;
    margin-bottom: 12px;
    line-height: 22px;
  }
}
</style>
